<template>
  <div
    class="py-20 my-20 min-h-96 flex flex-col justify-center items-center gap-8"
  >
    <img
      src="/img/network_issues.png"
      :alt="$t('main.itemsNotLoaded.error')"
      class="w-80"
    />
    <p class="text-neutral-400">
      {{ $t("main.itemsNotLoaded.error") }}
    </p>
  </div>
</template>
